const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;


export const getLocationNameByLatLng = async (lat, lng) => {
    let locationName = ''; // Default location name if no result is found
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (
      isNaN(latNum) || 
      isNaN(lngNum) || 
      latNum < -90 || 
      latNum > 90 || 
      lngNum < -180 || 
      lngNum > 180
    ) {
      console.error("Invalid latitude or longitude:", latNum, lngNum);
      return locationName; // Return early if invalid
    }
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latNum},${lngNum}&key=${apiKey}`
      );
  
      // Check if the response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
  
      // Get the formatted address from the response
      if (data.results && data.results.length > 0) {
        locationName = data.results[0].formatted_address;
      } else {
        console.warn("No results found for the given lat/lng:", lat, lng);
      }
    } catch (error) {
      console.error("Error fetching location name:", error);
    }
  
    return locationName;
  };
  
